"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BitbucketForksIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 12c0-.552.446-1 .998-1H12v2H3.998A.996.996 0 0 1 3 12"/><path fill-rule="nonzero" d="M12 11V9c0-.55.45-1 1-1h6.4V6H13c-1.65 0-3 1.34-3 3v2zm-2 2v2c0 1.66 1.35 3 3 3h6.4v-2H13c-.55 0-1-.45-1-1v-2z"/><path fill-rule="nonzero" d="M17.29 8.29A1 1 0 1 0 18.7 9.7l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41L18.59 7zm0 10a1 1 0 0 0 1.41 1.41l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41l1.3 1.31z"/></g></svg>`
}, props));
BitbucketForksIcon.displayName = 'BitbucketForksIcon';
var _default = exports.default = BitbucketForksIcon;